<template>
  <div class="col-lg-12 col-md-12 col-sm-12 p-0">
    <div class="row successfull mt-2"  v-if="stpFlow || issuePolicyNo">
      <div class="col">
        <img
          src="@/assets/images/group-3-copy-3@3x.png"
          class="done-logo"
          alt="done"
        />
      </div>
    </div>
    <!-- Payment Successful -->
    <div class="row"  v-if="stpFlow || issuePolicyNo || fromSendPaymentLinkCall || clearanceValidationMsg">
      <div class="col text-center">
        <p class="payment-successful mb-3" :class="{'mt-5' : fromSendPaymentLinkCall, 'mt-3' : !fromSendPaymentLinkCall}" v-if="paymentMode != 'CUSTOMERONLINE'">
          Payment Successful !</p>
        <h2 class="payment-successful mt-3 mb-3" v-if="paymentMode == 'CUSTOMERONLINE'">Payment Link Sent !</h2>
        <p class="mt-4 mb-2" id="policyText" v-if="paymentMode == 'CUSTOMERONLINE'">Payment link for your quotation number 
           <b><span class="policy-no">{{quoteId}}</span></b>&nbsp; has been sent successfully !
        </p>
        <p class="mt-3 mb-2" id="policyText" v-if="paymentMode == 'CUSTOMERONLINE' && linkExpiryDateTime">Payment link expires on:  
           <b><span class="policy-no">{{linkExpiryDateTime}}</span></b>&nbsp;
        </p>
        <p class="mt-4 mb-2" id="policyText" v-if="paymentMode != 'CUSTOMERONLINE' && !fromSendPaymentLinkCall && !clearanceValidationMsg">
          Policy Number - <b><span class="policy-no">{{issuePolicyNo}}</span></b
          >&nbsp; is issued successfully for {{state.planName}}
        </p>
        <p class="mb-5" id="policyText" v-if="scpaPolicyNoInNB && paymentMode != 'CUSTOMERONLINE' && !fromSendPaymentLinkCall && !clearanceValidationMsg">
          Policy Number - <b><span class="policy-no">{{scpaPolicyNoInNB}}</span></b
          >&nbsp; is issued successfully for Compulsory Personal Accident
        </p>
        <p class="mt-4 mb-2" id="policyText" v-if="paymentMode != 'CUSTOMERONLINE' && !fromSendPaymentLinkCall && clearanceValidationMsg">
          <span class="clear-validation-msg">{{clearanceValidationMsg}}</span>
        </p>
      </div>
    </div>
    <!-- Table -->
    <!-- Details -->
    <div class="row mt-4 payment-details-block mb-4 pb-4"  v-if="(stpFlow && paymentMode != 'CUSTOMERONLINE' && !fromSendPaymentLinkCall) || issuePolicyNo  || clearanceValidationMsg">
      <div class="col-lg-3 col-md-1 col-sm-6 col-12 blank-div"></div>
      <div class="col-lg-2 col-md-3 col-sm-12 col-12 amount-paid">
        <p class="payment-details mb-0">Amount Paid</p>
        <p class="value"><span class="rupee-symbol">₹</span>{{collectionAmountPaid}}</p>
      </div>
      <div class="col-lg-2 col-md-3 col-sm-12 col-12 px-0 date-of-pay">
        <p class="payment-details mb-0 mr-2">Date of Payment</p>
        <p class="value">{{collectionResponse.dop}}</p>
      </div>
      <div class="col-lg-2 col-md-3 col-sm-12 col-12 px-0 payment-method">
        <p class="payment-details mb-0">Payment Method</p>
        <p class="value mb-0">{{collectionResponse.paymentMethodDesc}}</p>
      </div>
    </div>
    <!-- Recommend policy starts-->
    <div v-if="stpFlow && false">
      <div class="d-flex recommend-pa-policy">
        <div class="col-lg-2 col-md-1 col-sm-1 col-0"></div>
        <div class="col-lg-1 col-md-1 col-sm-2 col-4">
          <img
            class="recommend-img"
            src="@/assets/images/Recomended_ribbon_3x.png"
          />
        </div>
        <div
          class="col-lg-8 col-md-8 col-sm-8 col-7 my-auto pl-lg-5 pl-md-5 pl-sm-4 ml-lg-4 ml-md-5 ml-sm-4 recommend-policy"
        >
          We recommend to get a <strong>PA Policy</strong> along with this Motor
          Insurance policy. Please click <a href=url>here</a> to Procced
        </div>
      </div>
    </div>
    <!-- Recommend policy ends-->
    <div class="row" v-if="!stpFlow && workFlowDetailStatus=='' && !issuePolicyNo && !fromSendPaymentLinkCall">
      <div class="col text-center my-5 py-5">
        <p v-if="quoteStatus == '' || quoteStatus == 'Quote Issued'" class="underwrite-remark">Quote No. <span class="policy-no">{{quotationNo}}</span> has been referred for Approval</p>
        <p v-if="quoteStatus == 'Rejected'" class="underwrite-remark">Quote No. <span class="policy-no">{{quoteId}}</span> has been Rejected by the Approver.</p>
        <p v-if="quoteStatus == 'Closed' || quoteStatus == 'ACTIVE POLICY'" class="underwrite-remark">Policy with No. <span class="policy-no">{{closedPolicyNo}}</span> has already been issued for Quote No. <span class="policy-no">{{quoteId}}</span>.</p>
        <p v-if="quoteStatus == 'More Info Required'" class="underwrite-remark">Quote No. <span class="policy-no">{{quoteId}}</span> is further pending for Approval</p>
        <p v-if="quoteStatus == 'New'" class="underwrite-remark">Quote No. <span class="policy-no">{{quotationNo}}</span> is already pending for approval</p>
      </div>
    </div>
    <!-- <div class="row" v-if="!stpFlow && workFlowDetailStatus!='' && !issuePolicyNo">
      <div class="col text-center my-5 py-5">
        <p class="underwrite-remark">Quote No. <span class="policy-no">{{quotationNo}}</span> is already pending for approval</p>
      </div>
    </div> -->
    <!-- <div class="row" v-if="rejectedQuote && rejectedQuote == 'Rejected'">
      <div class="col text-center my-5 py-5">
        <p class="underwrite-remark">Quote No. <span class="policy-no">{{quoteId}}</span> is rejected by the approver.</p>
      </div>
    </div> -->
    <hr />
  </div>
</template>

<script>
import { reactive, onMounted, computed} from '@vue/composition-api';
import PageTitle from "@/../../shared_component/PageTitle.vue";
import Breadcrumb from "@/../../shared_component/Breadcrumb.vue";

export default {
  name: "PolicySuccess",
  props: ["stpFlow","quotationNo",'scpaPolicyNoInNB','collectionAmountArr','collectionResponseForScpa','riskDetailsData','linkExpiryDateTime',
  'quoteStatus','issuePolicyNo','closedPolicyNo','collectionResponse','planCode','planArray','paymentMode','quoteId', 'workFlowDetailStatus',
  'fromSendPaymentLinkCall', 'clearanceValidationMsg'],
  components: {
    Breadcrumb,
    PageTitle
  },
  setup(props , context){
    let state = reactive({
        planName: ''
    });
    onMounted(()=>{
      setPlanName();
    });
    //computed
    const collectionAmountPaid = computed(()=>{
      let amountPaid = 0;
      // amountpaid = props.collectionResponse.amountPaid;
      for(let i=0;i<props.collectionAmountArr.length;i++){
        amountPaid+=+props.collectionAmountArr[i];
      }
      // if(props.riskDetailsData.cpaApplicability.value == 'S'){
      //   amountPaid+=+props.collectionResponseForScpa.amountPaid;
      // }
      return amountPaid;
    });
    //methods
    function setPlanName(){
      if(context.root.$store.getters.getMotorParentType.standaloneCPA){
        state.planName = 'Standalone Compulsory Personal Accident';
      }
      else{
        for(let i=0; i<props.planArray.length; i++){
          if(props.planCode.value == props.planArray[i].planCode){
              state.planName = props.planArray[i].planName;
          }
        }
      }
    }
    //return
    return{
      state,
      setPlanName,
      collectionAmountPaid
    }
  }
};
</script>

<style scoped>
.recommend-img {
  position: relative;
  bottom: 6px;
}
.clear-validation-msg{
  font-weight: bold;
  color: #0070BE;
}
.recommend-policy {
  font-size: 17px;
  color: #333333;
}
.recommend-pa-policy {
  background-color: rgba(30, 30, 30, 0.05);
  width: calc(100% + 66px);
  max-width: 1366px;
  margin: 30px 0px 53px -32px;
  height: 72px;
}
.done-logo {
  margin-top: 34px;
  text-align: center;
}
.payment-details-block {
  font-size: 18px !important;
  font-weight: normal;
}
.policy-no {
  font-weight: bold;
  color: #0070be;
}
.successfull {
  text-align: center;
}
.payment-successful {
  font-size: 30px;
  color: #333333;
}
.payment-details {
  color: #999999;
}
.rupee-symbol {
  color: #666666;
}
.value {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
}
@media (max-width: 767px) {
  .date-of-pay {
    text-align: center;
  }
  .amount-paid {
    text-align: center;
  }
  .payment-method {
    text-align: center;
  }
  .blank-div {
    display: none;
  }
}
@media (min-width: 768px) {
  .date-of-pay {
    text-align: center;
  }
  .amount-paid {
    text-align: center;
  }
  .payment-method {
    text-align: center;
  }
}
.btn {
  font-size: 16px;
  border: solid 1px #fcab10;
  border-radius: 5px;
  background-color: #ffffff;
  color: #666666;
}
.download-certificate {
  color: #ffffff;
  font-size: 16px;
  background-color: #fcab10;
  border-radius: 5px;
}
@media (max-width: 575px) {
  .payment-successful {
    font-size: 24px;
  }
  .blank-div {
    display: none;
  }
}
@media (max-width: 548px) {
  .blank-div {
    display: none;
  }
}
@media (max-width: 376px) {
  .blank-div {
    display: none;
  }
}
@media (max-width: 427px) {
  .recommend-policy {
    font-size: 13px;
  }
}
@media (max-width: 372px) and (min-width: 310px) {
  .recommend-policy {
    margin-left: 24px;
  }
}
</style>
